export default {
  notCanceledMeetings: ({ meetings }) =>
    meetings.filter(meeting => meeting.status !== 'CANCELADO'),
};
